import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/hooks/useAuth";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";
import Index from "./pages/Index";
import Vendors from "./pages/Vendors";
import VendorDetail from "./pages/VendorDetail";
import BackofficeDashboard from "./pages/backoffice/BackofficeDashboard";
import VendorAuth from "./pages/VendorAuth";
import Auth from "./pages/Auth";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Budget from "./pages/dashboard/Budget";
import WeddingSettings from "./pages/dashboard/WeddingSettings";
import Guests from "./pages/dashboard/Guests";
import Invitations from "./pages/dashboard/Invitations";
import InvitationEditor from "./pages/invitations/InvitationEditor";
import InvitationWizard from "./pages/invitations/InvitationWizard";
import GuestManager from "./pages/invitations/GuestManager";
import TemplateDemo from "./pages/invitations/TemplateDemo";
import PublicInvitation from "./pages/PublicInvitation";
import NotFound from "./pages/NotFound";
import AdminDashboard from "./pages/admin/AdminDashboard";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Index />} />
            <Route path="/vendors" element={<Vendors />} />
            <Route path="/vendor/:id" element={<VendorDetail />} />
            <Route path="/vendor-auth" element={<VendorAuth />} />
            <Route
              path="/backoffice"
              element={
                <ProtectedRoute redirectTo="/vendor-auth">
                  <BackofficeDashboard />
                </ProtectedRoute>
              }
            />
            <Route
              path="/admin"
              element={
                <ProtectedRoute>
                  <AdminDashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/auth" element={<Auth />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/dashboard/wedding" element={<ProtectedRoute><WeddingSettings /></ProtectedRoute>} />
            <Route path="/dashboard/settings" element={<ProtectedRoute><WeddingSettings /></ProtectedRoute>} />
            <Route path="/dashboard/budget" element={<ProtectedRoute><Budget /></ProtectedRoute>} />
            <Route path="/dashboard/guests" element={<ProtectedRoute><Guests /></ProtectedRoute>} />
            <Route path="/dashboard/invitations" element={<ProtectedRoute><Invitations /></ProtectedRoute>} />
            <Route path="/dashboard/vendors" element={<ProtectedRoute><Vendors /></ProtectedRoute>} />
            <Route path="/invitations/new" element={<ProtectedRoute><InvitationWizard /></ProtectedRoute>} />
            <Route path="/invitations/:id/wizard" element={<ProtectedRoute><InvitationWizard /></ProtectedRoute>} />
            <Route path="/invitations/:id/edit" element={<ProtectedRoute><InvitationEditor /></ProtectedRoute>} />
            <Route path="/invitations/:id/guests" element={<ProtectedRoute><GuestManager /></ProtectedRoute>} />
            <Route path="/invitations/demo/:templateId" element={<TemplateDemo />} />
            <Route path="/i/:slug" element={<PublicInvitation />} />
            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
